import PropTypes from 'prop-types';
import React from 'react';
import { retrieveBuildVersion } from '../actions/ConfigActionCreators';
import {connectToStores} from 'fluxible-addons-react';

@connectToStores(['ConfigStore'], (context) => {
  const ConfigStore = context.getStore('ConfigStore');

  return {
    buildVersion: ConfigStore.getBuildData().version || 'undefined'
  };
})
class BuildVersionNotifier extends React.PureComponent {
  static propTypes = {
    buildVersion: PropTypes.string.isRequired
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const that = this;
    function checkVersion() {
      that.context.executeAction(retrieveBuildVersion);
    }

    this._timeout = setInterval(checkVersion, 10000);
    this.mounted = true;
  }

  componentWillUnmount() {
    clearInterval(this._timeout);
  }

  render() {
    const { buildVersion } = this.props;

    return (this.mounted && buildVersion !== 'undefined') ? <div className='version-notifier text-center flex-off-shrink'>
      A new version of this page is available.&nbsp;&nbsp;
      <button className='btn btn-primary' onClick={() => window.location.reload()}>
        Click here to refresh
      </button>
    </div> : null;
  }
}

export default BuildVersionNotifier;



// WEBPACK FOOTER //
// ./src/components/BuildVersionNotifier.js